import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";

interface SchadenKICredentials {
  apiKey: string;
  apiUrl: string;
}

export async function saveSchadenKICredentials(apiKey: string, apiUrl: string): Promise<SchadenKICredentials> {
  try {
    const data = await authenticatedFetchJson<SchadenKICredentials>("/api/schaden-ki-credentials", {
      method: "POST",
      body: JSON.stringify({ apiKey, apiUrl }),
    });

    return {
      apiKey: data.apiKey || apiKey,
      apiUrl: data.apiUrl || apiUrl
    };
  } catch (error) {
    console.error("Error saving Schaden KI credentials:", error);
    throw error;
  }
}

